import React from 'react';

type PngExportModalContextType = {
    showPngExport: boolean;
    setShowPngExport: (open: boolean) => void;
};

const PngExportModalContext = React.createContext<PngExportModalContextType>({
    showPngExport: false,
    setShowPngExport: () => {},
});
export const usePngExportModalContext = () =>
    React.useContext(PngExportModalContext);

export default PngExportModalContext;
